import { useQuery } from "@tanstack/react-query";
import { get } from "../api/client";
import type { ActiveCall } from "../api/types";
import { useCan } from "../auth/session";
import { useVoice } from "./store";

export const activeCallsKey = ["calls", "active"] as const;

/**
 * Server-confirmed state of the user's live calls. Polls quickly while a call is live (hold,
 * transfer and recording state come only from the server) and slowly otherwise.
 */
export function useActiveCalls() {
  const { canAny } = useCan();
  const live = useVoice((s) => !!s.activeCallSid || s.sdkCallState !== null || s.incoming.length > 0);
  const enabled = canAny("calls.initiate", "calls.receive");
  return useQuery({
    queryKey: activeCallsKey,
    queryFn: () => get<{ items: ActiveCall[] }>("/calls/active").then((r) => r.items),
    enabled,
    refetchInterval: (q) => (live || (q.state.data?.length ?? 0) > 0 ? 1500 : 15_000),
    refetchIntervalInBackground: true,
  });
}
